module.exports = __webpack_public_path__ + "img/female.ab34c387.svg";